import { getValueByPath, getValueByProp } from '@/commons/filters';
import { convertObjectToFormData } from '@/commons/utils/object';
import { parseTime } from '@/commons/utils/time.utils';

export interface Utils {
    getValueByProp: (data: any, prop: string, defaultValue?: any) => any;
    convertObjectToFormData: (object: Object) => FormData;
    parseTime: (
        time?: object | string | number,
        cFormat?: string,
    ) => string | null;
    getValueByPath: (data: any, prop: string, defaultValue?: any) => any;

}

const utils = {
    getValueByProp,
    convertObjectToFormData,
    parseTime,
    getValueByPath,
};

export default utils;
